// extracted by mini-css-extract-plugin
export var link = "index-module--link--58572";
export var list = "index-module--list--baaf9";
export var listItem = "index-module--listItem--d4994";
export var root = "index-module--root--74c44";